import React, { useState, useEffect } from 'react'
import ContentWrapper from '../layouts/contentWrapper'
import Loading from '../../components/Loading';
import api from '../../services/api'
import ShowMessages from '../../components/Exceptions'
import setStatistic from '../../services/apiStatistic'
import { Button } from 'react-bootstrap';


import { SelectGroup, ValidationForm } from 'react-bootstrap4-form-validation';

export default function PermissionsUser(props) {
    const [loading, setLoading]                           = useState(false)
    const [loadingButton, setLoadingButton]               = useState(false)


    const [iduserviroma, setIdUserViroma ]    = useState(null)
    const [costcenterid, setCostCenterId ]    = useState(null)

    const [bonds, setBonds]                   = useState([])

    const [userDataVIROMA, setUserDataVIROMA]   = useState([])
    const [costCenterData,setCostCenterData] = useState([])

    const getUsers = async(value ) => {
        try {
            setLoading(true)
            const [_UserIntegration,_costCenterData, _data] = await Promise.all([
                api.get('/getUserIntegration').then(res => res),
                api.get('/getcostcenter').then(res => res),
                api.get('/user-sienge-integration').then(res => res)
            ]);

            setUserDataVIROMA(_UserIntegration.data.userVIROMA || [])
            setCostCenterData(_costCenterData.data)
            setBonds(_data.data)

            setLoading(false)

        } catch (response) {
            setLoading(false)
            ShowMessages(response)
        }
    }

    const handleDelete  = async(id) => {
        try {
            await api.delete(`/user-sienge-integration/${id}`)
                .then(async (response) => {
                    await api.get('/user-sienge-integration')
                        .then(responseData => {
                            setBonds(responseData.data)
                            setLoadingButton(false)
                            ShowMessages(response)
                        })

                })

        } catch (response) {
            ShowMessages(response)
        }
    }

    const handleSubmit = async(e) => {
        e.preventDefault()
        setLoadingButton(true)
      
        await api.post('/user-sienge-integration',{iduserviroma,costcenterid,costcenter : costCenterData.filter(_item => _item.id === parseInt(costcenterid))[0].name})
                 .then(async response => {
                    await api.get('/user-sienge-integration')
                             .then(responseData => {
                                setBonds(responseData.data)
                                setLoadingButton(false)
                                ShowMessages(response)
                            })
                  })
                 .catch(error => {
                    console.log(error)
                    ShowMessages(error)
                    setLoadingButton(false)
                 })


    }

    useEffect(() => {
        getUsers()
        setStatistic('maintenance\\integration-sienge')
    },[])

    return (
        <ContentWrapper className="content-wrapper-bottom81 ">
            <Loading loading={loading} addClass="heigth60vh"/>
            <div className={`container-lg container-100 ${(loading ? "hidden" : "")}`}>
                <div>
                    <div style={{padding: "10px", borderRadius: "5px", border: "1px solid #cacaca", width: "50%", marginTop:"15px"}}>
                        <div style={{marginTop: "-21px", backgroundColor: '#fff', width: "fit-content"}}>
                            <span>Permissões de Obras</span>
                        </div>
                        <div style={{marginTop:"15px"}}>
                            <ValidationForm  setFocusOnError={true}>
                                <div style={{marginTop:"15px", display:"flex", gap:"5px"}}>
                                    <div style={{width:"46%"}}>
                                        <label>Obra</label>
                                        <SelectGroup
                                            name="costcenterid"
                                            id="costcenterid"
                                            placeholder="Selecione"
                                            value={costcenterid}
                                            onChange={e => setCostCenterId(e.target.value)}
                                            className="form-select">
                                            <option value="">Selecione</option>
                                            {costCenterData.map((_item) => {
                                                return (<option value={_item.id}>{_item.name}</option>)
                                            })}
                                        </SelectGroup>
                                    </div>
                                    <div style={{width:"46%"}}>
                                        <label>Usuário VIROMA</label>
                                        <SelectGroup
                                            name="usergroup"
                                            id="usergroup"
                                            placeholder="Selecione"
                                            onChange={e => setIdUserViroma(e.target.value)}
                                            value={iduserviroma}
                                            className="form-select">
                                            <option value="">Selecione</option>
                                            {userDataVIROMA.map((_item) => {
                                                return (<option value={_item.iduser}>{_item.name}</option>)
                                            })}
                                        </SelectGroup>
                                    </div>


                                    <div style={{width:"8%", marginLeft:"15px", display:"flex",alignItems:"center"}}>
                                        <button type="button" disabled={loadingButton} className="btn btn-success" title="Vincular usuário" style={{marginTop:"18px"}} onClick={e => handleSubmit(e)}>{loadingButton ?<i className="fa fa-spinner fa-spin"/> : <i className="fa fa-user-check"/>}</button>
                                    </div>
                                </div>
                            </ValidationForm>

                            <div style={{overflowX:"auto",height:"310px", marginTop:"15px"}} className={`${bonds.length === 0 ? "hidden" : ""}`}>
                                <table className="table table-striped w-100" >
                                    <thead className="thead-theme">
                                        <tr className="head-th">
                                            <td className="head-th" style={{width:"45%"}}>Obra</td>
                                            <td className="head-th" style={{width:"45%"}}>Usuário</td>
                                            <td style={{textAlign:"center", width:"100px"}}>
                                                        ...
                                            </td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {bonds && bonds.map((item, key) => {
                                            return (
                                                <tr className="head-th" key={key}>
                                                    <td>{item.costcenter}</td>
                                                    <td>{item.userviroma}</td>

                                                    <td style={{textAlign:"center"}}>
                                                        <button type="button" className="btn btn-danger btn-sm" onClick={e => handleDelete(item.iduserintegrationsienge)}><em className="fa fa-trash" ></em></button>
                                                    </td>
                                                </tr>
                                                    )
                                                })}
                                    </tbody>
                                </table>
                            </div>

                            <div className={`box-sem-dados bg-warning ${bonds.length > 0 ? "hidden" : ""}`} style={{marginTop:"15px"}}>Ainda não foi incluido nenhum vinculo.</div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal-footer footer-fixed modal-footer-bottom-10">
                <Button className="btn-ligth-gray" onClick={e => window.removeTab(`tab_${props.id}`,e)}>
                    <em className="fa fa-door-closed"></em> Fechar
                </Button>
            </div>
        </ContentWrapper>
    )
}